<div class="forms-report-filter">
  <div
    class="forms-report-filter__header"
    (click)="isFilterExpanded = !isFilterExpanded"
    [ngClass]="{ 'forms-report-filter__header--expanded': isFilterExpanded }"
  >
    <div class="forms-report-filter__header__title">
      <mat-icon>filter_alt</mat-icon>
      {{ 'RATINGS.FILTER.TITLE' | translate }}
    </div>

    <div class="forms-report-filter__header__expand">
      <span *ngIf="isFilterExpanded">{{ 'RATINGS.FILTER.SEE_LESS' | translate }}</span>
      <span *ngIf="!isFilterExpanded">{{ 'RATINGS.FILTER.SEE_MORE' | translate }}</span>
    </div>
  </div>

  <div class="forms-report-filter__content" *ngIf="isFilterExpanded">
    <div class="forms-report-filter__content__date">
      <div class="forms-report-filter__content__date__text">
        {{ 'RATINGS.FILTER.FILTER_BY_DATE' | translate }}
      </div>
      <fc-date-input
        [control]="filterForm.get('initialDate')"
        [placeholder]="'RATINGS.FILTER.DATE_PLACEHOLDER' | translate"
        [max]="filterForm.get('finalDate').value"
        translateErrorPrefix="RATINGS.FILTER.ERRORS"
      ></fc-date-input>
      <div class="forms-report-filter__content__date__text">
        {{ 'RATINGS.FILTER.TO' | translate }}
      </div>
      <fc-date-input
        [control]="filterForm.get('finalDate')"
        [placeholder]="'RATINGS.FILTER.DATE_PLACEHOLDER' | translate"
        [min]="filterForm.get('initialDate').value"
        translateErrorPrefix="RATINGS.FILTER.ERRORS"
      ></fc-date-input>
    </div>
    <fc-maintenance-types-input [control]="filterForm.get('maintenanceTypes')"> </fc-maintenance-types-input>
    <fc-segments-input [control]="filterForm.get('segments')"></fc-segments-input>
    <fc-locations-input [control]="filterForm.get('locations')"></fc-locations-input>
    <fc-location-groups-input [control]="filterForm.get('locationGroups')"></fc-location-groups-input>
    <fc-companies-input [control]="filterForm.get('companies')"></fc-companies-input>
  </div>
</div>
